<template>
  <v-app class="backgroundPage">
    <template v-if="isAuthenticated">
      <authenticated-toolbar />
    </template>

    <alert />
    <page-loading />
    <live-stream-start-info :visible="$store.state.liveStreamStartInfoDialogShow" />
    <join-live-stream :visible="$store.state.joinLiveStreamDialoStatus"/>
    <live-stream :visible="$store.state.liveStreamDialogStatus"/>
    <thanks-detail-dialog :visible="$store.state.thanksDetailDialogStatus"/>
    <platform-store-modal :visible="$store.state.platformStoreStatus"/>

    <v-main :class="this.$route.name != 'login' ? 'mt-0' : null">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
import AuthenticatedToolbar from "./components/Menu/ToolbarIfAuthenticated";
import Alert from "./components/General/Alert.vue";
import LiveStreamStartInfo from "./components/LiveStream/LiveStreamStartInfo.vue";
import JoinLiveStream from "./components/LiveStream/JoinLiveStream.vue";
import LiveStream from "./components/LiveStream/LiveStream.vue";
import PageLoading from "./components/General/PageLoading.vue";
import ThanksDetailDialog from "./components/Thanks/ThanksDetailDialog.vue";
import PlatformStoreModal from "./components/General/PlatformStoreModal.vue";
import { mapGetters, mapActions } from "vuex";
console.log("");
export default {
  name: "App",
  components: {
    AuthenticatedToolbar,
    Alert,
    PageLoading,
    LiveStreamStartInfo,
    JoinLiveStream,
    LiveStream,
    ThanksDetailDialog,
    PlatformStoreModal
  },
  data: () => ({
    excludeRoutes: [
      'login',
      'childSafetyPolicy'
    ]
  }),
  async created() {
    if (this.isAuthenticated) {
      await this.authSocketConnection(this.$store.state.token);
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  methods: {
    getDefaultService() {
      if (!this.excludeRoutes.includes(this.$route.name)) {
        this.getNotifications();
        this.getTagList();
        this.remoteConfig();
      }
    },
    ...mapActions(["getNotifications", "getTagList", "authSocketConnection", "remoteConfig"]),
  },
  mounted() {
    this.getDefaultService();
    this.detectmob();
  },
};
</script>

<style>
@import "../public/css/global.css";
</style>
